import { AHText, Box, TouchableBox, AHFileIcon, AHFileIconType } from "arkh";
import React from "react";
import { graphql, useFragment } from "react-relay";
import { SignalDetailFiles_files$key } from "./__generated__/SignalDetailFiles_files.graphql";

export function SignalDetailFiles(props: {
  files: SignalDetailFiles_files$key;
  onFilePress?: (fileId: string, pageId: string) => void;
}) {
  const files = useFragment(
    graphql`
      fragment SignalDetailFiles_files on File @relay(plural: true) {
        id
        name
        formattedSize
        type
        pages {
          id
        }
      }
    `,
    props.files
  );

  if (files.length === 0) {
    return null;
  }

  return (
    <Box
      spaceHorizontal="medium"
      spaceTop="medium"
      spaceBottom="medium"
      style={{
        flexDirection: "row",
        flexWrap: "wrap",
        gap: 12,
      }}
    >
      {files.map((file) => {
        const firstPageId = file.pages?.[0]?.id;
        const canPress = props.onFilePress && firstPageId;

        const content = (
          <>
            <Box style={{ width: 30, height: 30, marginRight: 8 }}>
              <AHFileIcon filetype={file.type as AHFileIconType} size={30} />
            </Box>
            <Box style={{ flex: 1 }}>
              <AHText type="body" color="text-primary" numberOfLines={1}>
                {file.name}
              </AHText>
              <AHText type="detail" color="text-secondary">
                {file.formattedSize}
              </AHText>
            </Box>
          </>
        );

        return canPress ? (
          <TouchableBox
            key={file.id}
            color="surface"
            borderColor="border-primary"
            cornerRadius="medium"
            spaceHorizontal="small"
            spaceVertical="small"
            style={{
              borderWidth: 1,
              flexDirection: "row",
              alignItems: "center",
              minWidth: 200,
            }}
            onPress={() => props.onFilePress?.(file.id, firstPageId)}
          >
            {content}
          </TouchableBox>
        ) : (
          <Box
            key={file.id}
            color="surface"
            borderColor="border-primary"
            cornerRadius="medium"
            spaceHorizontal="small"
            spaceVertical="small"
            style={{
              borderWidth: 1,
              flexDirection: "row",
              alignItems: "center",
              minWidth: 200,
            }}
          >
            {content}
          </Box>
        );
      })}
    </Box>
  );
}
